import React, { Fragment } from 'react'
import { Formik } from "formik";
import Button from 'mineral-ui/Button'
import Loading from '../../components/Loading'
import { Modal, Close, SuccessText, ErrorText, Text, Title, FormContainer, SubTitle, TextInput, EditButton } from '../../theme'

/*
  Update Azure Vault Key
  @prop {vault} - vault name
  @prop {keyName} - key name
*/
export default ({ vault, keyName }) => {
  // Set up States
  const [showForm, setShowForm] = React.useState(false)
  const [submitted, setSubmitted] = React.useState(false)

  // Form Toggle
  function toggleForm() {
    setSubmitted(false)
    setShowForm(!showForm)
  }

  // Form Submit
  async function onSubmit({ value }, { setSubmitting, setErrors }) {
    setSubmitting(true);
    const response = await fetch(`/api/internal/key-vaults?action=keys&vaultname=${vault}&secretname=${keyName}&secretvalue=${value}`, 
      {method: 'PATCH', headers: {apikey: 'b7c4e1c4-80b3-4aed-af33-58507218395d'}})
    const data = await response.json()
    if(data.error){
        setErrors({ key: data.error })
        setSubmitted(false)
    } else {
        setSubmitted(true)
    }
    setSubmitting(false);
  }

  return (
    <Fragment>
        <EditButton size='1.5em' key='updateButton' onClick={toggleForm}/>
        {showForm ? (
            <Modal>
            <Close onClick={toggleForm} />
            <Formik
              initialValues={{ value: '' }}
              onSubmit={onSubmit}
            >
                { ({ errors, isSubmitting}) => (
                <FormContainer>
                    <Title>Update Key</Title>
                    <Title>{keyName}</Title>
                    <SubTitle>Vault: {vault}</SubTitle>

                    <Text>
                        Value:
                        <TextInput type="text" name="value" />
                    </Text>
                    <Text>
                        {!submitted || errors.key ? <Button
                            css={{ textTransform: 'uppercase' }}
                            type="submit"
                            primary
                            iconEnd={isSubmitting ? <Loading /> : null}
                        >
                            {isSubmitting ? '' : 'Submit'}
                        </Button> :
                        <Button primary onClick={toggleForm}>Close</Button>}
                    </Text>
                    {(errors.key || submitted) && (
                        <Text>
                            {errors.key && <ErrorText>{errors.key}</ErrorText>}
                            {submitted && !errors.key && <SuccessText>Secret Succesfully Updated</SuccessText>}
                        </Text>
                    )}
                </FormContainer>
                )}
            </Formik>
            </Modal>
        ) : null}
    </Fragment>
  );
}